const counterType = {
    INCREMENT: 'INCREMENT',
};

export default counterType;